import { useState } from "react";

const cards = [
  {
    title: "What We Believe",
    body: "At KGS Technology Group, we believe in the power of technology to transform businesses and improve lives. We are committed to delivering innovative solutions that empower our clients to succeed in a rapidly evolving digital landscape. Our team is passionate about staying up-to-date with the latest technologies and trends, and we are dedicated to helping our clients stay ahead of the curve.",
  },
  {
    title: "Quality Policy",
    body: "At KGS Technology Group, we are committed to maintaining the highest standards of quality and excellence. Our quality policy is centered on delivering solutions that meet or exceed our client's expectations while adhering to the highest standards of professionalism, ethics, and integrity. We use rigorous quality control processes to ensure our solutions are reliable, effective, and user-friendly.",
  },
  {
    title: "Our Business Philosophy",
    body: "Our business philosophy is based on a client-centric approach that prioritizes our client's needs and objectives above all else. We take the time to understand each client's unique challenges, goals, and opportunities and develop customized solutions that deliver tangible results. We are committed to building lasting relationships based on trust, collaboration, and shared success, and we strive to be a trusted partner to our clients every step of the way.",
  },
];

export default function KGSCards() {
  const [hovered, setHovered] = useState(null);

  return (
    <div
      className="flex items-center justify-center px-8 py-14 mb-6"
      style={{ background: "linear-gradient(135deg, #dce8f0 0%, #e8f0f7 50%, #d4e4ef 100%)" }}
    >
      <div className="w-full max-w-6xl grid grid-cols-1 md:grid-cols-3 gap-6">
        {cards.map((card, i) => (
          <div
            key={i}
            onMouseEnter={() => setHovered(i)}
            onMouseLeave={() => setHovered(null)}
            className="relative bg-white rounded-sm flex flex-col items-center text-center px-8 py-10 cursor-default transition-all duration-300"
            style={{
              boxShadow:
                hovered === i
                  ? "0 20px 50px rgba(10, 40, 90, 0.18), 0 4px 16px rgba(10, 40, 90, 0.10)"
                  : "0 6px 32px rgba(10, 40, 90, 0.10), 0 1px 4px rgba(10, 40, 90, 0.06)",
              transform: hovered === i ? "translateY(-6px)" : "translateY(0)",
            }}
          >
            {/* Top accent line */}
            <div
              className="absolute top-0 left-8 right-8 h-0.5 rounded-full transition-all duration-300"
              style={{
                background: hovered === i
                  ? "linear-gradient(90deg, #1a3a6b, #2e5fa3)"
                  : "transparent",
              }}
            />

            <h2
              className="text-xl font-bold mb-5 tracking-wide"
              style={{
                color: "#1a3a6b",
                fontFamily: "'Georgia', 'Times New Roman', serif",
                letterSpacing: "0.01em",
              }}
            >
              {card.title}
            </h2>

            <p
              className="text-sm leading-relaxed"
              style={{
                color: "#4a5568",
                fontFamily: "'Georgia', 'Times New Roman', serif",
                lineHeight: "1.85",
              }}
            >
              {card.body}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}